import {makeStyles} from '@material-ui/core/styles'

const useStyles = makeStyles({
    card: {
        boxShadow: '1px 2px 8px 1px rgba(0,0,0,0.41)',
        padding: '10px 30px',
        marginBottom: 20,
    }
})

export default useStyles
